module.exports = __webpack_public_path__ + "static/media/icon_155.db7df6e0.svg";